<template>
    <horizontal-text-image-section
        class="horizontal-text-image-section-module"
        :title="attributes.horizontalTextImageSection_title"
        :text="attributes.text"
        :desktop-image="desktopImage"
        :mobile-image="mobileImage"
        :background-image="backgroundImage"
        :reversed="attributes.reversed"
        :fluid-container="attributes.fluid_container"
        :text-column-width="attributes.text_column_width"
        :background-variant="attributes.horizontalTextImageSection_background_variant"
    />
</template>

<script>
    import HorizontalTextImageSection from '../../../organisms/HorizontalTextImageSection/HorizontalTextImageSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'horizontal-text-image-section-module',

        components: { HorizontalTextImageSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Return the desktop image object.
             *
             * @returns {{src: string|undefined, alt: string|undefined}}
             */
            desktopImage() {
                return formatMediaObject.call(this, this.attributes.desktop_image);
            },

            /**
             * Return the desktop image object.
             *
             * @returns {{src: string|undefined, alt: string|undefined}}
             */
            mobileImage() {
                return formatMediaObject.call(this, this.attributes.mobile_image);
            },

            /**
             * Return the background image object.
             *
             * @returns {{src: string|undefined, alt: string|undefined}}
             */
            backgroundImage() {
                return formatMediaObject.call(this, this.attributes.background_image);
            },
        },
    };
</script>
